import { CommonEntrypoint } from "entrypoint/CommonEntrypoint";
import 'presentation/style/index.scss';
import ParameterMaintenanceCont from "presentation/view/container/Parameter/ParameterContMain";

CommonEntrypoint(<ParameterMaintenanceCont/>)